module.exports = __webpack_public_path__ + "img/entree-normale-h900.e266e391.jpg";